import React, { useState } from 'react'
import DropDown from '../../../components/DropDown/DropDown'
import { ReactComponent as Ship } from '../../../assets/icons/ship.svg'
import { ReactComponent as Bed } from '../../../assets/icons/bed.svg'
import { ReactComponent as Attractions } from '../../../assets/icons/attractions.svg'
import { ReactComponent as TagIcon } from '../../../assets/icons/tag.svg'
import { ReactComponent as Close } from '../../../assets/icons/close.svg'
import './Tabs.scss'

const Tabs = ({
  forms,
  activeTab,
  setActiveTab,
  journeyType,
  journeyTypeOptions,
  setJourneyType,
  promoCode,
  setPromoCode,
  widgetType,
  hidePromoField,
  availableTabs,
}) => {
  const [localPromoCode, setLocalPromoCode] = useState(promoCode)

  return (
    <div className="Tabs">
      <div className="tabs-wrapper">
        {availableTabs.some(tab => tab === 'ferry') && (
          <div className={`tab ${activeTab === 'ferry' ? 'selected' : ''}`}>
            <button onClick={() => setActiveTab('ferry')}>
              <div
                className={`title ${activeTab === 'ferry' ? 'selected' : ''}`}
              >
                <Ship />
                <span>Ferry</span>
              </div>
            </button>
            <div
              className={`trip-type-radios ${
                widgetType === 'banner' ? 'display' : 'no-dispaly'
              }`}
            >
              {journeyTypeOptions?.map(option => (
                <label key={option.value}>
                  <input
                    type="radio"
                    value={option.value}
                    onChange={() => setJourneyType(option.value)}
                    checked={journeyType === option.value}
                  />
                  <p>{option.label}</p>
                </label>
              ))}
            </div>
          </div>
        )}

        {availableTabs.some(tab => tab === 'stay') && (
          <button
            className={`tab ${activeTab === 'stay' ? 'selected' : ''}`}
            onClick={() => setActiveTab('stay')}
          >
            <div className={`title ${activeTab === 'stay' ? 'selected' : ''}`}>
              <Bed />
              <span>Stay</span>
            </div>
          </button>
        )}
        {availableTabs.some(tab => tab === 'attractions') && (
          <button
            className={`tab ${activeTab === 'attractions' ? 'selected' : ''}`}
            onClick={() => setActiveTab('attractions')}
          >
            <div
              className={` title ${
                activeTab === 'attractions' ? 'selected' : ''
              }`}
            >
              <Attractions />
              <span>Attractions</span>
            </div>
          </button>
        )}

        <div className="tabs-remaining-space">
          {hidePromoField ? null : (
            <DropDown
              renderTrigger={({ toggleOpen }) =>
                promoCode ? (
                  <button
                    className="active-promo-code  items-center"
                    onClick={() => setPromoCode('')}
                  >
                    <TagIcon />
                    <p>{promoCode}</p>
                    <Close />
                  </button>
                ) : (
                  <button onClick={toggleOpen} className="add-promo-code">
                    Add a promo code +
                  </button>
                )
              }
              className="promo-code"
              dropDownClassName="enter-promo-code"
              onClickAway={() => setLocalPromoCode(promoCode)}
              renderChildren={({ toggleOpen }) => (
                <>
                  <div className="input-label">
                    <label>
                      <p>Promo code</p>
                      <input
                        value={localPromoCode}
                        onChange={e =>
                          setLocalPromoCode(e.target.value.toUpperCase())
                        }
                        autoFocus
                      />
                    </label>
                  </div>

                  <button
                    className="btn-primary"
                    onClick={e => {
                      setPromoCode(localPromoCode)
                      toggleOpen(e)
                    }}
                  >
                    Apply
                  </button>
                </>
              )}
            />
          )}
        </div>
      </div>

      {forms[activeTab]}
    </div>
  )
}

export default Tabs
